import { BrowserRouter, useLocation } from "react-router-dom";
import AnnouncementBanners from "./components/feature/AnnouncementBanners";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


// Announcements marked "Every page" — the store and home pages place their own.
function SiteAnnouncements() {
  const { pathname } = useLocation();
  if (pathname === "/" || pathname.startsWith("/store")) return null;
  return <AnnouncementBanners />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteAnnouncements />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
